import * as React from "react";
import { useState, useEffect } from 'react';
import {
  Filter,
  AutocompleteInput,
  Link,
  Toolbar,
  SaveButton,
  Button,
  TextInput,
  SelectInput,
  List,
  Edit,
  LongTextInput,
  NumberField,
  FunctionField,
  DateInput,
  Tab,
  ReferenceManyField,
  Datagrid,
  TabbedForm,
  EditButton,
  FormTab,
  ReferenceInput,
  TextField,
  Pagination,
  ReferenceField, showNotification,
  CardActions,
  

  DateField, GET_LIST, GET_ONE
} from "react-admin";
import RentalBookingForm from "../components/rentalBookingForm";
import moment from "moment";
import {
  values,
  groupBy,
  mapObjIndexed,
  map,
  prop,
  propOr,
  compose,
  filter,
  sum,
  isNil,
} from "ramda";
import { GenericInputFilter } from "../components/selectboxfilter/genericInputFilter";
import { TextBooleanField } from "../components/TextBooleanField";
import GenerateMagicLink from "../components/generateMagicLink";
import RequestCompleteProfile from "../components/requestCompleteProfile";
import styles from "../components/dashboard/Styles";

import Error from "@material-ui/icons/Error";
import Book from "@material-ui/icons/Book";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import People from "@material-ui/icons/People";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CambioEmail from "../components/CambioEmail";
import dataProviderFactory from "../dataProvider";
import { getPermissionRole } from "../util";
import { LinearProgress } from "@material-ui/core";

const cardActionStyle = {
  zIndex: 2,
 //display: "inline-block",
  float: "right",
};

const handleOpenBookingForm = rental =>{
  console.log(rental)
  return (
    <CardActions style={cardActionStyle}>
      <RentalBookingForm  bookingId={rental.record.booking_id} />
    </CardActions>
  )
}


const rowStyle = (record, index) => ({
  backgroundColor: record.rental_status === 3 ? "#cccccc" : ""
});

const ClientPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const ClientFilter = props => (
  <Filter {...props}>
    <TextInput label="Customer Id" source="id" alwaysOn />
    <TextInput label="First or Last Name" source="q" alwaysOn />
    <TextInput label="Client Email" source="client_email" alwaysOn />
    <GenericInputFilter
      label="Country"
      source="country_id"
      search_resource="countries"
      resource_field="country"
      resource_id="country_id"
      alwaysOn
    />
  </Filter>
);

const EditDamageButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `/vehicle_damages/${object.record.id}`,
        search: `?client_id=${object.record.client_id}`
      }}
      label="View"
      style={{ padding: "10px" }}
    >
      <Error />
    </Button>
  );
};

const SeePayment = object => {
  return (
    <React.Fragment>
      <Button
        component={Link}
        // target="_blank"
        to={{
          pathname: `/payments/${object.record.payment_id}/show`,
          search: `?client_id=${object.record.client_id}`
        }}
        label="View Charges"
        style={{ padding: "10px" }}
      >
        <Book />
      </Button>
    </React.Fragment>
  );
};

const SeeItemButton = object => {
  return (
    <React.Fragment>
      <Button
        component={Link}
        target="_blank"
        to={{
          pathname: `/${object.record.type === 1 ? "tour_clients" : "rental_clients"
            }/${object.record.id}/show`
          // search: `?from=tour_list`
        }}
        label="Details"
        style={{ padding: "10px" }}
      >
        <RemoveRedEyeIcon />
      </Button>
    </React.Fragment>
  );
};

const shirtSizes = [
  { _id: 1, description: "S (EU) | XS (US)" },
  { _id: 2, description: "M (EU) | S (US)" },
  { _id: 3, description: "L (EU) | M (US)" },
  { _id: 4, description: "XL (EU) | L (US)" },
  { _id: 5, description: "XXL (EU) | XL (US)" },
  { _id: 6, description: "XXXL (EU) | XXL (US)" },
];

const AddDamageButton = object => {
  if (object.record.vehicle[0] !== undefined) {
    if (object.record.rental_status === 3) {
      return "";
    }

    return (
      <React.Fragment>
        <Button
          component={Link}
          to={{
            pathname: `/vehicle_damages/create`,
            search: `?client_id=${object.record.client_id}&rental_id=${object.record.id}&vehicle_id=${object.record.vehicle[0].id}`
          }}
          label="Add Damage"
          style={{ padding: "10px" }}
        >
          <Error />
        </Button>
      </React.Fragment>
    );
  } else {
    return <React.Fragment />;
  }
};

const BookingRentalButton = ({record}) =>{
  return (
    <FunctionField
        addLabel={false}
        render={() => {
          console.log(record)
          return <RentalBookingForm bookingId={record.booking_id} />;
        }}
      />
  );
}

const GenerateLink = object => {
 
  if ([1, 2, 3, 9].includes(getPermissionRole())) {
 
  return <GenerateMagicLink record={object.record} />;
  }
  else{
    return "";
  }
};

const RequestInfoLink = object => {
  if ([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) {
    return (
      <RequestCompleteProfile
        record={object.record}
        clientId={object.record && object.record.id}
      />
    );
  }
  return "";
};

export const ClientList = props => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      const dataProvider = await dataProviderFactory("rest");
      dataProvider(GET_LIST, 'countries', {
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'country', order: 'ASC' },
          filter: {}
      })
      .then(response => {
          setCountries(response.data);
          setLoading(false);
      })
      .catch(error => {
          console.error("Error fetching countries", error);
          setLoading(false);
      });
    };
    fetchCountries();
  }, []);

  const renderNationality = (record) => {
    if (loading || !record || !record.nationality) return '';

    const nationalityValue = record.nationality;
    
    // Si ya es un ID numérico
    const parsedId = parseInt(nationalityValue, 10);
    if (!isNaN(parsedId)) {
      const country = countries.find(c => c.id === parsedId);
      return country ? country.country : nationalityValue;
    }
    
    // Si es un string (ej. "Hong Kong")
    const lowerCaseValue = String(nationalityValue).toLowerCase();
    const country = countries.find(c => c.country.toLowerCase() === lowerCaseValue);
    return country ? country.country : nationalityValue;
  };

  return (
    <List
      {...props}
      resource="clients"
      pagination={<ClientPagination />}
      filters={<ClientFilter />}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField label="Customer ID" source="id" />
        <TextField label="First Name" source="client_first_name" />
        <TextField label="Last Name" source="client_last_name" />
        <TextField label="City" source="client_city" />
        <FunctionField label="Nationality" render={renderNationality} />
        <TextField label="Other Email" source="other_email" />
        <ReferenceField
          label="Country"
          source="country_id"
          reference="countries"
          linkType={false}
        >
          <TextField source="country" />
        </ReferenceField>
        <DateField label="Birthdate" source="client_birth_date" />
        <ReferenceField
          label="Email"
          source="user_id"
          reference="users"
          linkType={false}
          allowEmpty={true}
        >
          <TextField source="email" />
        </ReferenceField>
        <EditButton />
        <GenerateLink />
        <RequestInfoLink />
      </Datagrid>
    </List>
  );
};

const ClientTitle = object => (
  <span>
    {" Edit Client "} &quot;
    {`${object.record.client_first_name} ${object.record.client_last_name}`}
    &quot;
  </span>
);

const EditToolbar = props => {

  return (
  <Toolbar {...props}>
    {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
      <SaveButton redirect={`/clients`} style={{ padding: "10px", marginRight: 10 }} />   
    )}
    {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
      <CambioEmail basePath="clients" style={{ backgroundColor: 'red' }} label="Update Email" /> 
    )}
    {/* <SaveButton redirect={`/clients`} style={{ padding: "10px", marginRight:10 }} />
    <CambioEmail basePath="clients" style={{ backgroundColor: 'red' }} label="Update Email" /> */}
    <Button
      component={Link}
      to={{
        pathname: `/clients`
      }}
      label="Back to clients"
    >
      <ArrowBackIcon />
    </Button>

    {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && (
      <div style={{ display: "flex", alignItems: "center", marginLeft: 10, paddingLeft: 10 }}>
      <RequestCompleteProfile style={{ marginLeft: 10, paddingLeft: 10 }}
        record={props.record}
        clientId={
          (props.record && props.record.id) ||
          (props.props && props.props.record && props.props.record.id)
        }
      />
      </div>
    )}
  </Toolbar>)
};

function Fecha(date){
  // DateInput (input type="date") exige YYYY-MM-DD; DD-MM-YYYY queda Invalid Date
  // cuando el día > 12, y con día <= 12 el navegador puede invertir día/mes.
  if (!date) return '';
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

const ClientEditForm = props => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      const dataProvider = await dataProviderFactory("rest");
      dataProvider(GET_LIST, 'countries', {
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'country', order: 'ASC' },
          filter: {}
      })
      .then(response => {
          setCountries(response.data);
          setLoading(false);
      })
      .catch(error => {
          console.error("Error fetching countries", error);
          setLoading(false);
      });
    };

    fetchCountries();
  }, []);

  const formatNationality = value => {
    if (loading || !value || countries.length === 0) {
        return value; 
    }

    if (typeof value === 'number') {
        return value;
    }

    if (typeof value === 'string') {
        const parsedId = parseInt(value, 10);
        if (!isNaN(parsedId)) {
            return parsedId;
        }

        const lowerCaseValue = value.toLowerCase();
        const country = countries.find(c => c.country.toLowerCase() === lowerCaseValue);
        if (country) {
            return country.id;
        }
    }

    return value;
  };

  if (loading) {
      return <LinearProgress />;
  }

  return (
    <TabbedForm {...props} toolbar={<EditToolbar props={{...props}}/>}>
      <FormTab label="General Data">
        <ReferenceManyField
          reference="vehicle_damages"
          target="client_id"
          sort={{ field: "damage_date", order: "DESC" }}
          label="Damages"
        >
          <Datagrid>
            <TextField source="rental_id" label="Rental Id" />
            <ReferenceField
              label="Licence Plate"
              source="vehicle_id"
              reference="vehicles"
              linkType={false}
            >
              <TextField source="licence_plate" />
            </ReferenceField>
            <ReferenceField
              label="Model"
              source="vehicle_id"
              reference="vehicles"
              linkType={false}
            >
              <ReferenceField
                source="vehicle_model_id"
                reference="vehicle_models"
                linkType={false}
              >
                <TextField source="model_name" />
              </ReferenceField>
            </ReferenceField>
            <DateField source="damage_date" label="Date" />
            <ReferenceField
              label="Location"
              source="location_id"
              reference="locations"
              linkType={false}
            >
              <TextField source="location_name" />
            </ReferenceField>
            <NumberField
              source="cost"
              options={{ style: "currency", currency: "EUR" }}
              label="Cost"
            />
            <NumberField
              source="ammount_charged"
              options={{ style: "currency", currency: "EUR" }}
              label="Charged"
            />
            <TextField source="p4m" label="P4M" />
            <TextField source="km" label="KM" />
            <TextField source="comment" label="Comment" />
            <EditDamageButton />
          </Datagrid>
        </ReferenceManyField>
        <ReferenceField
          source="user_id"
          reference="users"
          label="Username"
          linkType={false}
        >
          <TextField source="username" />
        </ReferenceField>
        <ReferenceField
          source="user_id"
          reference="users"
          linkType={false}
          label="Email"
        >
          <TextField source="email" label="Email" />
        </ReferenceField>
        <TextBooleanField label="Terms Acceptance" source="accepted_terms" />
        <TextBooleanField label="Receive Newsletter" source="receive_information" />
        <TextInput label="Other Email" source="other_email" />
        <TextInput label="First Name" source="client_first_name" />
        <TextInput label="Last Name" source="client_last_name" />
        <TextInput label="Nickname" source="nickname" />
        <ReferenceInput
          label="Country"
          source="country_id"
          reference="countries"
        >
          <AutocompleteInput optionText="country" />
        </ReferenceInput>
       
       <ReferenceInput
          label="Nationality"
          source="nationality"
          reference="countries"
          format={formatNationality}
        >
          <AutocompleteInput optionText="country" />
        </ReferenceInput>
        
        <LongTextInput label="Address" source="client_address" />
        <TextInput label="City" source="client_city" />
        <TextInput label="Zip" source="client_zip" />
        <TextInput label="State" source="client_state" />
        <DateInput label="Birthdate" source="client_birth_date"  locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
        <TextInput label="Client Phone" source="client_phone" />
        <TextInput label="Client Work Phone" source="client_work_phone" />
        <TextInput label="DNI/Passport" source="passport" />
        <TextInput label="Driver's licence" source="driving_licence" />

        <SelectInput
          label="Client T-Shirt Size"
          source="client_shirt"
          choices={shirtSizes}
          optionText="description"
          optionValue="_id"
          alwaysOn
        />
        <LongTextInput
          source="comments"
          label="Comments"
          type="text"
          InputLabelProps={{
            shrink: true
          }}
        />
      </FormTab>
      <FormTab label="Rentals">
        <Tab label="Rentals" path="rentals">
          <ReferenceManyField
            addLabel={false}
            reference="rentals"
            target="client_id"
            filter={{ type: "2", show_all: "1" }}
            perPage={10}
            sort={{ field: "date_1", order: "DESC" }}
            pagination={<ClientPagination />}
          >
            <Datagrid rowStyle={rowStyle}>
              <TextField source="booking_id" label="Booking Id" />
              <TextField source="id" label="Rental Id" />
              <ReferenceField
                label="Licence Plate"
                source="main_vehicle_id"
                reference="vehicles"
                allowEmpty
              >
                <TextField source="licence_plate" />
              </ReferenceField>
              <ReferenceField
                label="Model"
                source="main_vehicle_id"
                reference="vehicles"
                linkType={false}
              >
                <ReferenceField
                  source="vehicle_model_id"
                  reference="vehicle_models"
                  linkType={false}
                >
                  <TextField source="model_name" />
                </ReferenceField>
              </ReferenceField>
              <DateField source="date_1" label="Pick-up Date" />
              <DateField source="date_2" label="Drop-off Date" />
              <ReferenceField
                label="Pick-up city"
                source="location_id_1"
                reference="locations"
                linkType={false}
              >
                <TextField source="location_name" />
              </ReferenceField>
              <ReferenceField
                label="Drop-off city"
                source="location_id_2"
                reference="locations"
                linkType={false}
              >
                <TextField source="location_name" />
              </ReferenceField>
              {( [1, 2, 3, 4, 6, 9].includes(getPermissionRole()) &&
                <AddDamageButton />
              )}
              <BookingRentalButton />
              <SeeItemButton />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </FormTab>
      <FormTab label="Tours (As Rider)">
        <Tab label="Tours" path="rentals">
          <ReferenceManyField
            addLabel={false}
            reference="rentals"
            target="client_id"
            filter={{ type: "1", show_all: "1" }}
            sort={{ field: "date_1", order: "DESC" }}
          >
            <Datagrid rowStyle={rowStyle}>
              <TextField source="booking_id" label="Booking Id" />
              <TextField source="id" label="Rental Id" />
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Tour"
              >
                <ReferenceField
                  source="tour_id"
                  reference="tours"
                  linkType={false}
                >
                  <ReferenceField
                    source="tour_name_id"
                    reference="tour_names"
                    linkType={false}
                  >
                    <TextField source="tour_name_en" />
                  </ReferenceField>
                </ReferenceField>
              </ReferenceField>

              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Self Guided"
              >
                <ReferenceField
                  source="tour_id"
                  reference="tours"
                  linkType={false}
                >
                  <TextBooleanField source="self_guided" />
                </ReferenceField>
              </ReferenceField>

              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Start Date"
              >
                <ReferenceField
                  source="tour_id"
                  reference="tours"
                  linkType={false}
                >
                  <DateField source="tour_start_date" />
                </ReferenceField>
              </ReferenceField>
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="First Name"
              >
                <TextField source="r_first_name" />
              </ReferenceField>
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Last Name"
              >
                <TextField source="r_last_name" />
              </ReferenceField>
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Nickname"
              >
                <TextField source="nickname" />
              </ReferenceField>
              <ReferenceField
                label="Licence Plate"
                source="main_vehicle_id"
                reference="vehicles"
              >
                <TextField source="licence_plate" />
              </ReferenceField>
              <ReferenceField
                label="Model"
                source="main_vehicle_id"
                reference="vehicles"
                linkType={false}
              >
                <ReferenceField
                  source="vehicle_model_id"
                  reference="vehicle_models"
                  linkType={false}
                >
                  <TextField source="model_name" />
                </ReferenceField>
              </ReferenceField>
              {( [1, 2, 4, 6, 9].includes(getPermissionRole()) &&
                <AddDamageButton />
              )}
              <BookingRentalButton />
              <SeeItemButton />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </FormTab>
      <FormTab label="Tours (As passenger)">
        <Tab label="Tours - Passenger" path="tours_passenger">
          <ReferenceManyField
            addLabel={false}
            reference="tours_passenger"
            target="client_id"
            filter={{ type: "1", show_all: "1", as_passenger: true }}
            sort={{ field: "date_1", order: "DESC" }}
          >
            <Datagrid rowStyle={rowStyle}>
              <TextField source="booking_id" label="Booking Id" />
              <TextField source="id" label="Rental Id" />
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Tour"
              >
                <ReferenceField
                  source="tour_id"
                  reference="tours"
                  linkType={false}
                >
                  <ReferenceField
                    source="tour_name_id"
                    reference="tour_names"
                    linkType={false}
                  >
                    <TextField source="tour_name_en" />
                  </ReferenceField>
                </ReferenceField>
              </ReferenceField>
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="Start Date"
              >
                <ReferenceField
                  source="tour_id"
                  reference="tours"
                  linkType={false}
                >
                  <DateField source="tour_start_date" />
                </ReferenceField>
              </ReferenceField>
              <ReferenceField
                source="booking_id"
                reference="bookings"
                linkType={false}
                label="End Date"
              >
                <ReferenceField
                  source="tour_id"
                  reference="tours"
                  linkType={false}
                >
                  <DateField source="tour_end_date" />
                </ReferenceField>
              </ReferenceField>
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </FormTab>
      <FormTab label="Payments and Rewards">
        <Tab label="Rewards" path="rewards">
          <ReferenceManyField
            addLabel={false}
            reference="rewards"
            target="client_id"
            filter={{ with_rewards: "true" }}
            sort={{ field: "start_date", order: "ASC" }}
          >
            <Datagrid>
              <TextField source="payment_id" label="Payment Id" />

              <ReferenceField
                source="payment_id"
                reference="payments"
                linkType={false}
                label="Type"
                allowEmpty={true}
              >
                <TextField source="type" />
              </ReferenceField>

              <SeePayment />

              <ReferenceField
                source="payment_id"
                reference="payments"
                linkType={false}
                label="Payment Date"
                allowEmpty={true}
              >
                <DateField source="date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
              </ReferenceField>
              <ReferenceField
                source="payment_id"
                reference="payments"
                linkType={false}
                label="Payment Value"
                allowEmpty={true}
              >
                <NumberField
                  source="value"
                  options={{ style: "currency", currency: "EUR" }}
                />
              </ReferenceField>

              <ReferenceField
                source="payment_id"
                reference="payments"
                linkType={false}
                label="Tour / Rental"
                allowEmpty={true}
              >
                <FunctionField
                  addLabel={false}
                  render={t => {
                    const rental = t.rentals[0];
                    let desc = `Rental Id ${rental.id}`;
                    if (rental.type === 1) {
                      desc = `Tour (${rental.id}) - ${rental.booking.tour.tour_name.tour_name_en}`;
                    }
                    return desc;
                  }}
                />
              </ReferenceField>
              <DateField source="start_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} label="Reward Start Date" />
              <DateField source="expire_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} label="Reward Expire Date" />
              <TextField source="points_earned" label="Points Earned" />
              <TextField source="points_used" label="Points Used" />
            </Datagrid>
          </ReferenceManyField>

          <FunctionField
            label={'Expiration Dates'}
            render={client => {
              const getYearMonth = m => moment(m).format("YYYYMMDD");
              const onlyActiveRewardPoints = filter(reward => moment(reward.start_date).isSameOrBefore(Date.now(), 'day'),
                propOr([], 'remainingRewards', client))

              const grouped = groupBy(
                compose(getYearMonth, prop("expire_date")),
                onlyActiveRewardPoints
              );
              const sumGruped = mapObjIndexed(
                (value, key) => sum(map(prop("points_earned"), value)),
                grouped
              );
              return values(
                mapObjIndexed((item, key) => {
                  if (item > 0 && moment(key).isSameOrAfter(Date.now(), 'day')) {
                    return (
                      <React.Fragment>
                        {item} points expiring on{" "}
                        {moment(key).format("DD-MM-YYYY")}
                        <br />
                      </React.Fragment>
                    );
                  }
                }, sumGruped)
              );
            }}
          />

          <FunctionField
            label={'Points Pending'}
            render={client => {
              const getYearMonth = m => moment(m).format("YYYYMMDD");
              const grouped = groupBy(
                compose(getYearMonth, prop("start_date")),
                client.rewards
              );
              const sumGruped = mapObjIndexed(
                (value, key) => sum(map(prop("points_earned"), value)),
                grouped
              );
              return values(
                mapObjIndexed((item, key) => {
                  if (item > 0 && moment(key).isSameOrAfter(Date.now(), 'day')) {
                    return (
                      <React.Fragment>
                        {item} points available on{" "}
                        {moment(key).format("DD-MM-YYYY")}
                        <br />
                      </React.Fragment>
                    );
                  }
                }, sumGruped)
              );
            }}
          />

          <FunctionField
            label={'Points Total'}
            render={client => {
              return (
                <React.Fragment>
                  {`Total Expired Points: ${client.expiredRewards}`}
                  <br />
                  {`Total Available Points: ${client.availableRewards}`}
                  <br />
                  {`Total Used Points: ${client.usedRewards}`}
                </React.Fragment>
              );
            }}
          />

          <FunctionField
            label={'Rewards Used'}
            render={client => {
              return (
                <React.Fragment>
                  {propOr([], 'remainingRewards', client).map(reward => {
                    if (reward.points_used > 0) {
                      if (!isNil(reward.notes)) {
                        return (<React.Fragment>{`${reward.notes} on ${reward.payment.type} #${reward.payment.type_id} (${reward.points_used} points used)`}<br /></React.Fragment>);
                      }
                      else {
                        return (<React.Fragment>{`Discount on ${reward.payment.type} #${reward.payment.type_id} (${reward.points_used} points used)`}<br /></React.Fragment>);
                      }
                    }
                  })}
                </React.Fragment>
              );
            }}
          />
        </Tab>
      </FormTab>
    </TabbedForm>
  );
};

export const ClientEdit = (props) => (
  <Edit title={<ClientTitle />} {...props}>
    <ClientEditForm {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/clients.js